import React from 'react'
import CoursesPage from './CoursesPage'
import Footer from '../../components/Footer'
import LMSNavbar from './Navbar/LMSNavbar'

const Dashboard = () => {
  
  return (
    <> 
        <LMSNavbar />
        <CoursesPage />
        <Footer />
    </>
  )
}

export default Dashboard
